import { render, staticRenderFns } from "./widthExpand.vue?vue&type=template&id=51804d6c&scoped=true&"
import script from "./widthExpandControl.js?vue&type=script&lang=js&"
export * from "./widthExpandControl.js?vue&type=script&lang=js&"
import style0 from "./widthExpand.css?vue&type=style&index=0&id=51804d6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51804d6c",
  null
  
)

export default component.exports